module.exports = __webpack_public_path__ + "static/media/gameover.51a809df.mp3";